var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"21.5","stroke":"#00B09A","key":0}),React.createElement("path",{"d":"M19 26.1701L14.83 22.0001L13.41 23.4101L19 29.0001L31 17.0001L29.59 15.5901L19 26.1701Z","fill":"#00B09A","key":1})]);
}

Checkmark.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
